// extracted by mini-css-extract-plugin
module.exports = {"sideNav":"side-nav_sideNav__uJ1lR","active":"side-nav_active__OU6hr"};